import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidatePortfolioOnForbidden } from "web_myplann/Api/Portfolio/invalidatePortfolioOnForbidden";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPropertyFlatDetailResponseDTO,
	type ClientPropertyFlatEditRequestDTO,
	patchPropertyFlatIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPropertyFlatMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPropertyFlatDetailResponseDTO,
		Error,
		Partial<ClientPropertyFlatEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPropertyFlatIdV2(requestContract, id),
		),
		onError: (error) => invalidatePortfolioOnForbidden(queryClient, error),
		onSuccess: (data) => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.propertyList() });
			queryClient.setQueryData(PortfolioKeys.propertyDetail(id), data);
		},
	});
};
